import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ContactUsListLayer from "../components/ContactUsListLayer";

const ContactUsListPage = () => {
    return (
        <MasterLayout>
            <ContactUsListLayer />
        </MasterLayout>
    );
};

export default ContactUsListPage;
